import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import * as FileSaver from 'file-saver/FileSaver';
import { Store } from '@ngrx/store';
import * as CoverActions from '@core/actions/cover.actions';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class CoverApiService {

  constructor(private http: HttpClient, private store: Store<any>) { }

  /* create(data) {
    console.log('CREATE_data ===>', data)
    const followsIds = `FollowIds=${data.FollowIds}&FollowFirst=${data.FollowFirst}&FollowCompared=${data.FollowCompared}`
    return this.http.get(
        `${API}covers/export?${followsIds}&businessUnit=${data.businessUnit}&countryId=${data.countryId}&mainShipments=${data.mainShipments}&comparedShipments=${data.comparedShipments}&categoryN3=${data.categoryN3}&destCenters=${data.destCenters}`,
        {
          responseType: 'blob',
          observe: 'response'
        }
      ).subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(
            blob,
            `Carátulas`
          );
          this.store.dispatch(new CoverActions.CreateSuccess());
        },
        err => {
          this.store.dispatch(new CoverActions.CreateFail(err));
        }
      );
  } */


	create(data) {
		return this.http.post<any>(`${API}covers/export`, data);
	}

  get(data) {
    // console.log('data ===>', data)

    // console.log('is herereer')
    const followsIds = `FollowIds=${data.FollowIds}&FollowFirst=${data.FollowFirst}&FollowCompared=${data.FollowCompared}`
    return this.http.get(
        `${API}covers/productShipments?${followsIds}&businessUnit=${data.businessUnit}&countryId=${data.countryId}`
      )
  }
}
